import { QADetailsStatusOptions } from "../../../utils/statusUtils";

/**
 * Calendar-only status rules (Home > Calendar widget). This is the single switch for how the
 * Calendar labels a test, without touching QA Details, which calls the same status helpers with
 * no options and keeps the legacy behavior.
 *
 * Used by:
 *  - Calendar.tsx: tile dots and the selected-day list rows (getComplianceStatus)
 *  - CalendarWidget.tsx: the TestList drawer opened from a Calendar row (TestList statusOptions)
 *  - CalendarLegend.tsx: shows the "Overdue" legend entry only when pastDueStatus is "overdue"
 *
 * pastDueStatus - a test whose cycle has already closed without a run (its due day is before
 *   today, e.g. a semi-annual run 04/02 was due 10/01) shows on today's tile as:
 *     "overdue" - client request 2026-11-04 (current)
 *     "due"     - legacy / Audit Report wording. Set this to revert after the client review.
 *   A test whose due day IS today always reads "Due".
 *
 * skipWeekendsForDaily - a daily test's due day on Sat/Sun counts as the following Monday for
 *   the check above, so a daily test last run on Friday is "Due" (not "Overdue") on Monday.
 *   Keep it in step with the calendar-compliance API's includeWeekends (default false).
 *
 * See zapit-api/docs/CALENDAR_COMPLIANCE.md.
 */
export const CALENDAR_STATUS_OPTIONS: Readonly<Required<QADetailsStatusOptions>> = {
  // The Calendar keeps the full compliance set (Missed / Incomplete / Pending / Skipped / Due /
  // Not Due) - the QA Details "current" model (Due / Overdue / Not Due / Pending only) is
  // QA-Details-only, see MachineTests/qaDetailsStatusConfig.ts.
  statusModel: "compliance",
  pastDueStatus: "overdue",
  skipWeekendsForDaily: true,
};
